import { render } from "./changeStatus.vue?vue&type=template&id=664c2192&ts=true"
import script from "./changeStatus.vue?vue&type=script&lang=ts"
export * from "./changeStatus.vue?vue&type=script&lang=ts"

import "./changeStatus.vue?vue&type=style&index=0&id=664c2192&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__